import {StocksFiltersSchema} from '@/modules/stocks/schemas'
import {RestVialStatus} from '@cypro/engine/database/schema'
import {SortSchema} from '@cypro/ui/schemas'
import * as z from 'zod'

export const RestVialsFiltersSchema = StocksFiltersSchema.extend({
  categories: z.array(z.uuid()).optional(),
  stockLocations: z.array(z.uuid()).optional(),
  status: z.array(RestVialStatus).optional(),
})

export const RestVialsSearchSchema = z.object({
  filters: RestVialsFiltersSchema.default({status: [RestVialStatus.enum.AVAILABLE, RestVialStatus.enum.IN_USE]}),
  sort: z.array(SortSchema).default([{id: 'createdAt', desc: true}]),
})

export const NewBatchSearchSchema = z.object({
  batchId: z.uuidv7().optional(),
})
